import type { IndexedDBConnector } from '@/types/accessor/common/connector'
import * as indexedDB from './common/indexedDBController'

import { handleError } from '../util/errorHandler'
import { latLonToQuadKey } from '@/utils/mathUtils/mathUtils'
import type {
  ArgQueryBuilding,
  QueryBuildingResult,
  ResQueryBuilding
} from '@/types/accessor/api/building/building'
import type { ObjectStoreName } from '@/types/accessor/indexedDB'
import { METHOD, SEND_STATE } from '@/constants/accessor/indexedDB/indexedDB'

const STORE_NAME: ObjectStoreName = 'building'
const IDB_ERROR_CODE = 'idb_01'
export const set: IndexedDBConnector<ResQueryBuilding, undefined, void> = async (
  data?: ResQueryBuilding
) => {
  if (!data?.result) {
    return
  }

  await Promise.all(
    data.result.map(
      async (d: QueryBuildingResult) =>
        await indexedDB.set(STORE_NAME, d, METHOD.GET, SEND_STATE.FETCHED, d.buildingId)
    )
  ).catch(async () => await handleError(IDB_ERROR_CODE))
}

export const get: IndexedDBConnector<string, undefined, unknown> = async (buildingId?: string) => {
  return (await indexedDB
    .get(STORE_NAME, buildingId!)
    .catch(async () => await handleError(IDB_ERROR_CODE))) as IndexedDBConnector
}

export const getAll: IndexedDBConnector<ArgQueryBuilding, undefined, unknown> = async (
  param?: ArgQueryBuilding
) => {
  const res = (await indexedDB
    .getAll(STORE_NAME)
    .catch(async () => await handleError(IDB_ERROR_CODE))) as QueryBuildingResult[]
  if (param!.lat != null && param!.lng != null && param!.radius != null) {
    const quadKey = latLonToQuadKey(param!.lat, param!.lng, 23)
    // ズームレベル15で一致する建物で絞り込みする
    return res.filter(d => d.quadkey.indexOf(quadKey.substring(0, 15)) === 0)
  }
  return res
}
